module.exports = __webpack_public_path__ + "img/img_logo_posco_mexico_white.ade6129c.png";